import {KeyValue} from './keyValue';

export class GroupRole extends KeyValue {
    constructor () {
        super();
    }
    permissionList: Array<string> = [];
}
